import { PlatformVariant } from '@/entities/platforms/types'
import { createEvent } from 'effector'

export const AppStarted = createEvent()
export const goToOnboarding = createEvent()
export const goToMain = createEvent()
export const goToLastProgress = createEvent()
export const goToRecommendations = createEvent()
export const goToEpicProfile = createEvent()
export const goToXboxProfile = createEvent()
export const goToNews = createEvent<{ variant: string }>()
export const goToProfile = createEvent()
export const goToUpdate = createEvent()
export const goOnPrivateError = createEvent()
export const goToAuth = createEvent()
export const goToConnection = createEvent()
export const onError = createEvent()
export const goToNewAuth = createEvent()
export const goToCaseList = createEvent()
export const goToTon = createEvent()
export const goToReward = createEvent()
export const goToTest = createEvent()
export const goToDevTools = createEvent()
export const goToDoubleConnection = createEvent<{ platform: PlatformVariant }>()
export const goToConnectSteam = createEvent()
export const goToTransactionStatus = createEvent<{ hash: string }>()
export const goToTransactionHistory = createEvent()
export const goToTopUpSteam = createEvent()
export const goToCase = createEvent<{ id?: number }>()
export const goToDailyBonus = createEvent<{ variant: 'default' | 'farcana' }>()
export const goToSocial = createEvent<void | { tab?: number }>()
export const goToUnifiedProfile = createEvent()
export const goToTasks = createEvent<void | { tab?: number }>()
export const goToConnectPlatform = createEvent<{ platform: PlatformVariant }>()
export const goToFarcanaProfile = createEvent()
export const goToExternalUnifiedProfile = createEvent<{ tid: number; gamed_id: string; fromSocialTab?: number }>()
export const goToShop = createEvent<void | { tab?: number }>()
export const goToUpdating = createEvent()
export const goToStarterPack = createEvent()
export const goToStarterPackClaim = createEvent()
